import { render } from "./share-modal-settings.vue?vue&type=template&id=385b5f18&scoped=true&ts=true"
import script from "./share-modal-settings.vue?vue&type=script&lang=ts"
export * from "./share-modal-settings.vue?vue&type=script&lang=ts"

import "./share-modal-settings.vue?vue&type=style&index=0&id=385b5f18&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385b5f18"]])

export default __exports__